module.exports = __webpack_public_path__ + "img/presencial-linea-tel.8aa557ef.svg";